import React from 'react'
import ButtonsGroups from '../components/Container/ButtonsGroups'
import ProductsContainer from '../components/Container/ProductsContainer'
import CartContainer from '../components/layout/CartContainer'
import Cartnavbar from '../components/layout/Cartnavbar'
import Footer from '../components/layout/Footer'
import Navbar from './Navbar'

const Cart = () => {
  return (
    <div>
      <Navbar/>
        <Cartnavbar/>
        <div className='lg:px-36  px-3 py-5'>
        <div className=''>
         <CartContainer/>
        </div>

        <div className=' mt-12 pt-8 border border-transparent border-t-black'>
           <h1 className='text-lg font-semibold px-4 '>You may also like </h1>
           <div className='w-full p-2'>
             <ButtonsGroups/>
           </div>
           <div>
             <ProductsContainer/>
           </div>
        </div>
        </div >
        <Footer/>
         </div>
  )
}

export default Cart